import { STATUS_PAGE_SUMMARY_URL, StatusPageSummaryResponse } from './types';

/**
 * Loads the public Statuspage summary payload used to render the in-app status banner.
 */
export async function fetchStatusPageSummary(): Promise<StatusPageSummaryResponse> {
  const response = await fetch(STATUS_PAGE_SUMMARY_URL, {
    method: 'GET',
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(
      `Statuspage summary request failed for ${STATUS_PAGE_SUMMARY_URL} with status ${response.status} ${response.statusText}`
    );
  }

  return (await response.json()) as StatusPageSummaryResponse;
}
